module.exports = __webpack_public_path__ + "img/meIcon.6ef0ab57.png";